import React from "react";

import PropTypes from "prop-types";
import ReactLoading from "react-loading";

// material-ui components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import TerminalDetail from "components/Terminal/TerminalDetail";
import TerminalCard from "components/Terminal/TerminalCard";
import SiteSelection from "components/Terminal/SiteSelection";

import httpr from "lib/httpRequest";
import { BASE_URL } from "lib/config";

const styles = (theme) => ({
  card: {
    width: "100%",
  },
  cardSelected: {
    border: "1px solid #4CAF50",
  },
  kisanSelected: {
    border: "1px solid #4287f5",
  },
  title: {
    fontSize: 20,
  },
  subheader: {
    fontSize: 14,
  },
  subTitle: {},
  subTitleRight: {
    float: "right",
  },
  media: {
    height: 0,
    paddingTop: "0%", // 16:9
  },
  actions: {
    display: "flex",
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  avatarError: {
    backgroundColor: "#b0252d",
    height: 75,
    width: 75,
    fontFamily: "Roboto, sans-serif",
    fontWeight: 600,
    fontSize: "200%",
  },
  avatarOk: {
    backgroundColor: "#4caf50",
    height: 75,
    width: 75,
    fontFamily: "Roboto, sans-serif",
    fontWeight: 600,
    fontSize: "200%",
  },
  avatarBlue: {
    backgroundColor: "#4287f5",
    height: 75,
    width: 75,
    fontFamily: "Roboto, sans-serif",
    fontWeight: 600,
    fontSize: "200%",
  },
  cardContent: {
    backgroundColor: "#4CAF50",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 600,
    fontSize: "200%",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
  cardTitleBlack: {
    color: "#000000",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "200",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "0px",
    textDecoration: "none",
  },
});

class Terminal extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      terminals: null,
      selected: null,
      isLoading: true,
      anchorEl: null
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.getTerminalCardInfo();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getTerminalCardInfo = () => {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    // Fetch data from api
    fetch
      .get(`${BASE_URL}${this.props.dataUrl}`) // /api/terminal/location/:locationId
      .then((response) => {
        const terminals = response.data;
        //map through and find first terminal that does not have F_DELETE set to true
        const selected = terminals[0];
        if (this._isMounted === true) {
          this.setState({
            terminals: terminals,
            selected: selected,
            selectedSite: selected.SITE_ID,
            isLoading: false,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleTerminalChange = (terminal) => {
    this.setState({ selected: terminal });
  };

  // update selected site and set selected terminal as first occurrence of that siteId
  handleSiteChange = (siteId) => {
    this.setState({ selectedSite: siteId}, () => {
      let tempT;
      for (const terminal of this.state.terminals) {
        if(terminal.SITE_ID === siteId){
          tempT = terminal;
          break;
        }
      }
      this.handleTerminalChange(tempT);
    });
  }

  handleMenuClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  }
  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  }

  render() {
    const { classes, isSocalDemo, locationId } = this.props;
    const { terminals, selected, selectedSite, anchorEl } = this.state;

    let terminalView;

    if (this.state.isLoading === true) {
      return (
        <ReactLoading
          type="spin"
          color="#000000"
          style={{
            width: "20%",
            margin: "auto",
          }}
        />
      );
    } else {
      terminalView = terminals.map((terminal) => {
        if (terminal.SITE_ID === selectedSite){
          if (!terminal.TERMINAL_NAME.includes("RUMS")) {
            const { location } = terminal;
            return (
              <GridItem key={terminal.TERMINAL_ID ? terminal.TERMINAL_ID : terminal.TERMINAL_NAME} xs={12} sm={12} md={4}>
                <TerminalCard
                  name={terminal.TERMINAL_NAME}
                  total={terminal.TOTAL}
                  status={terminal.STATUS}
                  model={terminal.model}
                  classes={classes}
                  location={location}
                  selected={
                      terminal.TERMINAL_ID === undefined ? 
                      (selected.TERMINAL_NAME === terminal.TERMINAL_NAME ? true: false)
                      : (selected.TERMINAL_ID === terminal.TERMINAL_ID ? true : false) 
                  }
                  handleTerminalChange={this.handleTerminalChange}
                  terminal={terminal}
                />
              </GridItem>
            );
        }}
      });
    }

    return (
      <div>
        <SiteSelection classes={classes} locationId={locationId} selectedSite={this.state.selectedSite} handleSiteChange={this.handleSiteChange}/>
        <GridContainer>{terminalView}</GridContainer>
        <br />
        {(selected.SITE_ID === selectedSite) && (
          <TerminalDetail terminal={selected} />
        )}
      </div>
    );
  }
}

Terminal.propTypes = {
  classes: PropTypes.object.isRequired,
  locationId: PropTypes.number.isRequired,
};

export default withStyles(styles)(Terminal);



// WEBPACK FOOTER //
// ./src/components/Terminal/Terminal.jsx